import React from 'react'

/** Checkbox labels shown on risk profiler last step and /accept-NDA fallback. */
export const NDA_ACCEPTANCE_CHECKBOX_LABELS = {
  confidentiality:
    'I confirm that I have reviewed and understood the Confidentiality & Non-Disclosure Undertaking. I agree to be bound by the terms and confirm to not use, disclose, copy, or otherwise misappropriate the information for any purpose other than that for which it was provided to me.',
  noOffer:
    'I acknowledge that the information contained in this platform is not considered to be an offer, or solicitation, to make any investment or deal in any of the investments or fund mentioned herein.',
  kycDocuments:
    'I confirm that I will submit genuine, valid and unaltered documents for KYC verification',
  adverseMedia:
    'I declare that I am not associated with any adverse media, negative news, allegations, investigations, legal proceedings, regulatory actions, or other publicly available information.',
} as const

type NdaConfidentialityLabelProps = {
  onOpenDocument: () => void
}

/** Confidentiality label with an in-page control to open the original agreement text. */
export const NdaConfidentialityLabel = ({ onOpenDocument }: NdaConfidentialityLabelProps) => (
  <>
    I confirm that I have reviewed and understood the{' '}
    <button
      type='button'
      className='nda-acceptance-doc-link'
      data-testid='nda-confidentiality-doc-link'
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onOpenDocument()
      }}
    >
      Confidentiality & Non-Disclosure Undertaking.
    </button>
    <br />
    {
      'I agree to be bound by the terms and confirm to not use, disclose, copy, or otherwise misappropriate the information for any purpose other than that for which it was provided to me.'
    }
  </>
)
